module.exports = __webpack_public_path__ + "img/07.a8259078.png";